import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getAdminSession, getAdminToken } from './adminSession';

export default function AdminRequireAuth({ children }: { children: ReactNode }) {
  // 관리자 토큰이 없는 이전 세션은 다시 로그인 (관리자 API 서버 인증)
  if (!getAdminSession() || !getAdminToken()) {
    return <Navigate to="/admin" replace />;
  }
  return <>{children}</>;
}
